package com.nonopn.skywatcher.app.utils

class AppBackPressProvider {
    private var onBackPressed: () -> Boolean = {
        false
    }

    fun registerOnBackPress(onBackPress: () -> Boolean) {
        onBackPressed = onBackPress
    }

    fun onBackPress() = onBackPressed()
}